import { gql } from 'graphql-request';

export const WidgetItemQuery = gql`
  query WidgetItem($id: ID!, $language: String) {
    WidgetItem(id: $id, language: $language, find_by: "full_slug") {
      id
      content {
        _uid
        _editable
        component
        personalization
        showLocalizedUSP
        exludeLocalizedUspForMarkets
        agentCityPrefix
        isSearchProfile
        enableExitPopup
        localizedUspLabel
        closeModalTitle
        closeModalSubtitle
        closeModalCloseModalText
        closeModalCloseWidgetText
        closeButtonText
        enableReset
        trustIconsList
        cancelIcon {
          id
          alt
          filename
        }
        steps
        maxNumberOfSteps
        footer
        analyticsMap
        marketingHeaderText
        logo {
          id
          alt
          filename
        }
        contactPerson {
          id
          alt
          filename
        }
      }
    }
  }
`;
